module.exports = __webpack_public_path__ + "img/bannerGreen.949f290d.jpg";